/* Messe-Landingpage — scroll-gekoppelte Szenen.
   Natives Scrollen bleibt unangetastet. Pro Frame wird der Ziel-Fortschritt
   jeder Szene aus der Scrollposition berechnet und der angezeigte Wert weich
   nachgezogen (lerp) → ruhige, „schwere" Bewegung auch bei ruckeligem
   Touch-Scroll. Layout wird nur bei Größenänderung gemessen, nie pro Frame. */
(function () {
  'use strict';
  var root = document.querySelector('[data-mx]');
  if (!root || root.__mx) return;
  root.__mx = true;
  root.classList.add('mx--js');

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var code = root.getAttribute('data-code') || '';
  var rabatt = root.getAttribute('data-rabatt') || '';
  var shareUrl = root.getAttribute('data-share') || location.origin;
  var status = root.querySelector('[data-mx-status]');

  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function ease(t) { return t * t * (3 - 2 * t); }                 // smoothstep
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }

  // ── Vorname aus der Eintragung (nur sessionStorage) ──
  try {
    var n = sessionStorage.getItem('vaupel_messe_name');
    var nameEl = root.querySelector('[data-mx-name]');
    if (n && nameEl) {
      nameEl.textContent = n;
      nameEl.hidden = false;
      if (n.length > 6) nameEl.classList.add('mx-name--long');
      root.querySelector('[data-mx-hello]').classList.add('mx-has-name');
    }
  } catch (e) {}

  // ── Danke-Zeilen: nie umbrechen, bei Bedarf Schrift verkleinern ──
  function fitLines() {
    root.querySelectorAll('[data-mx-fit]').forEach(function (el) {
      if (el.hidden) return;
      el.style.fontSize = '';
      var avail = el.parentElement.clientWidth, need = el.scrollWidth;
      if (need > avail && need > 0) {
        var fs = parseFloat(getComputedStyle(el).fontSize);
        el.style.fontSize = (fs * avail / need * 0.98).toFixed(1) + 'px';
      }
    });
  }
  fitLines();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitLines);
  addEventListener('resize', fitLines);

  // ── Szenen einlesen ──
  var scenes = Array.prototype.map.call(root.querySelectorAll('[data-mx-scene]'), function (el) {
    var segs = (el.getAttribute('data-seg') || '').trim().split(/\s+/).filter(Boolean).map(function (t) {
      var m = t.split(':'), r = m[1].split(',');
      return { name: m[0], from: +r[0], to: +r[1] };
    });
    return {
      el: el, segs: segs, cur: 0, tgt: 0, last: -1, top: 0, len: 1,
      stage: el.querySelector('.mx-stage'),
      track: el.querySelector('[data-mx-track]'),
      steps: Array.prototype.slice.call(el.querySelectorAll('[data-mx-step]')),
      count: el.querySelector('[data-mx-count]'),
      code: el.querySelector('[data-mx-code]'),
      actions: el.querySelector('[data-mx-actions]'),
      dist: 0
    };
  });
  var bar = root.querySelector('[data-mx-bar]');
  var marquees = Array.prototype.slice.call(root.querySelectorAll('[data-mx-marquee]'));
  var docMax = 1;

  if (reduce) { root.classList.add('mx--static'); }

  function measure() {
    var y = window.scrollY || pageYOffset, vh = innerHeight;
    scenes.forEach(function (s) {
      var r = s.el.getBoundingClientRect();
      s.top = r.top + y;
      s.len = Math.max(1, s.el.offsetHeight - vh);
      if (s.track) {
        s.dist = Math.max(0, s.track.scrollWidth - s.stage.clientWidth);
        s.stepPos = s.steps.map(function (st) { return st.offsetLeft + st.offsetWidth / 2; });
      }
    });
    marquees.forEach(function (m) { m.__w = m.scrollWidth / 4; });   // 4 gleiche Kopien
    docMax = Math.max(1, document.documentElement.scrollHeight - vh);
  }

  // Zeichen für die Code-Entschlüsselung
  var POOL = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  function scramble(t) {
    var shown = Math.floor(t * code.length), out = '';
    for (var i = 0; i < code.length; i++) {
      out += i < shown ? code[i] : POOL[(Math.random() * POOL.length) | 0];
    }
    return out;
  }

  function apply(s) {
    var p = s.cur, st = s.el.style;
    st.setProperty('--p', p.toFixed(4));
    var v = {};
    s.segs.forEach(function (g) {
      v[g.name] = ease(clamp((p - g.from) / (g.to - g.from)));
      st.setProperty('--' + g.name, v[g.name].toFixed(4));
    });

    // Ticket: Rabatt zählt hoch, Code entschlüsselt sich während der Drehung
    if (s.count) {
      var to = +s.count.getAttribute('data-to') || 0;
      var tb = clamp(((v.b || 0) - .45) / .55);
      s.count.textContent = Math.round(easeOut(tb) * to);
    }
    if (s.code && code) {
      var tc = clamp(((v.b || 0) - .5) / .5);
      s.code.textContent = tc >= 1 ? code : scramble(tc);
    }
    if (s.actions) s.actions.classList.toggle('is-on', (v.c || 0) > .6);

    // Schritte: Spur horizontal, Karte in der Mitte groß, Nachbarn kleiner
    if (s.track) {
      var x = -p * s.dist;
      s.track.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)';
      var center = s.stage.clientWidth / 2 - x;
      var w = s.steps[0] ? s.steps[0].offsetWidth : 300;
      s.steps.forEach(function (stp, i) {
        var d = Math.min(1, Math.abs(s.stepPos[i] - center) / w);
        stp.style.setProperty('--d', d.toFixed(3));
      });
    }
  }

  var running = false, lastScroll = 0;
  function frame(now) {
    var y = window.scrollY || pageYOffset, moving = false;
    scenes.forEach(function (s) {
      s.tgt = clamp((y - s.top) / s.len);
      var diff = s.tgt - s.cur;
      if (Math.abs(diff) > 0.0004) { s.cur += diff * 0.14; moving = true; } else { s.cur = s.tgt; }
      if (s.cur !== s.last) { apply(s); s.last = s.cur; }
    });
    if (bar) bar.style.transform = 'scaleX(' + Math.min(1, y / docMax).toFixed(4) + ')';
    marquees.forEach(function (m) {
      if (!m.__w) return;
      var off = (y * 0.45) % m.__w;
      var mx = m.getAttribute('data-dir') === '-1' ? off - m.__w : -off;
      m.style.transform = 'translate3d(' + mx.toFixed(1) + 'px,0,0)';
    });
    if (moving || now - lastScroll < 250) { requestAnimationFrame(frame); } else { running = false; }
  }
  function kick() {
    lastScroll = performance.now();
    if (!running) { running = true; requestAnimationFrame(frame); }
  }

  if (!reduce) {
    measure();
    scenes.forEach(function (s) { s.cur = s.tgt = clamp(((window.scrollY || 0) - s.top) / s.len); apply(s); });
    addEventListener('scroll', kick, { passive: true });
    var rt;
    addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { measure(); kick(); }, 120); });
    addEventListener('load', function () { measure(); kick(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { measure(); kick(); });
    kick();
  } else if (code) {
    var c0 = root.querySelector('[data-mx-count]');
    if (c0) c0.textContent = c0.getAttribute('data-to');
  }

  // ── Einblenden von Elementen im normalen Fluss ──
  var reveals = root.querySelectorAll('[data-mx-reveal]');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e, i) {
        if (e.isIntersecting) {
          e.target.style.transitionDelay = (i * 0.08) + 's';
          e.target.classList.add('is-in'); io.unobserve(e.target);
        }
      });
    }, { threshold: 0.3 });
    reveals.forEach(function (r) { io.observe(r); });
  } else {
    reveals.forEach(function (r) { r.classList.add('is-in'); });
  }

  // ── Aktionen ──
  function say(t) {
    if (!status) return;
    status.textContent = t;
    clearTimeout(say._t);
    say._t = setTimeout(function () { status.textContent = ''; }, 3200);
  }

  var copyBtn = root.querySelector('[data-mx-copy]');
  if (copyBtn) copyBtn.addEventListener('click', function () {
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = code; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); say('Kopiert: ' + code); } catch (e) { say('Code: ' + code); }
      ta.remove();
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () { say('Kopiert: ' + code); }, fallback);
    } else { fallback(); }
    if (navigator.vibrate) navigator.vibrate(12);
  });

  var shareBtn = root.querySelector('[data-mx-share]');
  if (shareBtn) shareBtn.addEventListener('click', function () {
    var text = rabatt + ' Messerabatt bei VAUPEL Fashion & Shoes in Gerbstedt. Hier eintragen und Rabatt sichern:';
    if (navigator.share) {
      navigator.share({ title: 'VAUPEL Messerabatt', text: text, url: shareUrl }).catch(function () {});
    } else {
      location.href = 'https://wa.me/?text=' + encodeURIComponent(text + ' ' + shareUrl);
    }
  });

  var saveBtn = root.querySelector('[data-mx-save]');
  if (saveBtn) saveBtn.addEventListener('click', function () {
    var w = 1080, h = 1350, c = document.createElement('canvas');
    c.width = w; c.height = h;
    var x = c.getContext('2d');
    var cs = getComputedStyle(root);
    var head = cs.getPropertyValue('--font-head').trim() || 'sans-serif';
    var mono = cs.getPropertyValue('--font-mono').trim() || 'monospace';
    x.fillStyle = '#121C2A'; x.fillRect(0, 0, w, h);
    // Ticket
    x.fillStyle = '#FAFAF8'; x.fillRect(90, 330, 900, 600);
    x.fillStyle = '#121C2A';
    x.beginPath(); x.arc(90, 630, 26, 0, Math.PI * 2); x.arc(990, 630, 26, 0, Math.PI * 2); x.fill();
    x.fillStyle = '#FAFAF8'; x.font = '600 60px ' + head; x.fillText('VAUPEL', 90, 170);
    x.globalAlpha = .6; x.font = '26px ' + mono; x.fillText('FASHION & SHOES · SEIT 1929', 90, 220); x.globalAlpha = 1;
    x.fillStyle = '#14161A';
    x.globalAlpha = .55; x.font = '26px ' + mono; x.fillText('MESSERABATT', 150, 410); x.globalAlpha = 1;
    x.font = '600 230px ' + head; x.fillText(rabatt, 140, 640);
    x.globalAlpha = .55; x.font = '26px ' + mono; x.fillText('CODE', 150, 760); x.globalAlpha = 1;
    x.font = '600 84px ' + mono; x.fillText(code, 150, 850);
    x.fillStyle = '#FAFAF8'; x.globalAlpha = .6; x.font = '30px sans-serif';
    x.fillText('Im Geschäft beim Bezahlen vorzeigen', 90, 1080);
    x.fillText(root.getAttribute('data-addr') || 'Gerbstedt', 90, 1130);
    x.globalAlpha = 1;
    c.toBlob(function (blob) {
      if (!blob) return say('Mach einfach einen Screenshot.');
      var file = new File([blob], 'vaupel-messerabatt.png', { type: 'image/png' });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        navigator.share({ files: [file], title: 'VAUPEL Messerabatt' }).catch(function () {});
      } else {
        var url = URL.createObjectURL(blob), a = document.createElement('a');
        a.href = url; a.download = 'vaupel-messerabatt.png';
        document.body.appendChild(a); a.click(); a.remove();
        setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
        say('Bild gespeichert.');
      }
    }, 'image/png');
  });
})();
